module.exports = __webpack_public_path__ + "img/user-white.ad6a42a1.svg";